<template>
    <Header
        elements="9"
        current="9"
    ></Header>
    <Pay
        formSlug="trademark-office-action"
        stepBack="step-6"
    ></Pay>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import Pay from '@/components/Pay.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Pay
    },
    mounted() {
        to_top()
    }
}
</script>
